import React,{useState,useEffect,useContext} from "react";
import Spinner from 'react-bootstrap/Spinner'
import {Row,Col} from "reactstrap";
import firebase from "firebase/app";
import { Redirect } from "react-router-dom";
import { AdminContext } from "../Context/Context";

export const Orders=()=>{
    const [orders,setOrders]=useState({});
    const {admin}=useContext(AdminContext);
  const [loading,setLoading]=useState(true);
      const getData=async ()=>{
        const orderRef=await firebase.database().ref(`/authorders`);
    orderRef.on('value',(snapshot)=>{
      setOrders(snapshot.val());
      console.log(snapshot.val());
      setLoading(false);
    })
      }
    useEffect(()=>{getData()},[]);
    return(
        <div>
         {
            loading==true?(<div><Spinner animation="border" className="spinner"/></div>):(<div></div>)
          }
      {(orders !=={}&&orders!=null) ?(Object.entries(orders).map(([key,value])=>
          (<div class="card" key={key} style={{width:"100%"}}>
                  
                  
                  <div>
                 {
                   (true) ?(value.map((val)=>(
                   <Row>
                    <Col className="md-6">
                    <img src={val.image} style={{width:"180px",height:"170px"}} class="card-img-top" alt="..."/>
                    </Col>
                    <Col className="md-6">
                    <div class="card-body" >
                    <div><h6><span style={{color:"#0A79DF"}}>Weight:</span>{val.weight} {"g"}</h6></div>
                    <div><h6><span style={{color:"#0A79DF"}}>Cost:</span> {val.cost}</h6></div>
                    </div>
                    </Col>
                    </Row>
                   )
                   )):(<></>)
                 }
                 </div>  
                    <div><h6><span style={{color:"#0A79DF"}}>Email:</span> {value[value.length-4]}</h6></div>
                    <div><h6><span style={{color:"#0A79DF"}}>Name:</span> {value[value.length-3]}</h6></div>
                    <div><h6><span style={{color:"#0A79DF"}}>Phone Number:</span> {value[value.length-2]}</h6></div>
                  
                  
              
              <Row>
                <Col className="md-6">
                <img src={value[3]} style={{width:"180px",height:"170px"}} class="card-img-top" alt="..."/>
                </Col>
              <Col className="md-6">
                <img src={value[value.length-1]} style={{width:"180px",height:"170px"}} class="card-img-top" alt="..."/>
                 </Col>
              </Row>
              </div> 
            ))):(<div>No Orders</div>)}
            {
              admin==true ?(<></>):(<Redirect to="/auth"/>)
            }
            </div>
    )
}